__turbopack_context__.v({
  "fade-in": "AccordionList-module-scss-module__PHF5NW__fade-in",
  "list": "AccordionList-module-scss-module__PHF5NW__list",
  "no-transform": "AccordionList-module-scss-module__PHF5NW__no-transform",
  "rotate": "AccordionList-module-scss-module__PHF5NW__rotate",
});
